/* @flow */

import * as React from 'react';

import classnames from 'classnames';
import {getSingularEntityType} from 'nutshell-core/utils/get-singular-entity-type';

import {RemoveButton} from '../button';
import {colors, type ColorName} from '../colors';

import './entity-pill.module.css';

const STYLED_PILL_TYPES = [
    'leads',
    'users',
    'teams',
    'contacts',
    'accounts',
    // straight color overrides
    'dark',
    'light',
    'colorName',
    'leftBorder',
];

type Props = {
    name?: string | React.Node,
    sublabel?: string | React.Node,
    type: string,
    htmlUrl?: string,
    isLinkable?: boolean,
    onRemove?: () => any,
    isSmall?: boolean,
    removeButtonTooltip?: string,
    colorName?: ColorName,
    tooltipText?: ?string,
};

export function EntityPill(props: Props) {
    const {type = 'default', isLinkable = true} = props;

    const entityName =
        props.name &&
        ((typeof props.name === 'string' && props.name.length) ||
            // typeof on React.Node returns an object :(
            typeof props.name === 'object') ? (
            <span>{props.name}</span>
        ) : (
            <span styleName='nameless'>Unnamed {getSingularEntityType(type)}</span>
        );

    const clickNavigatesToEntity = isLinkable && props.htmlUrl;

    const classes = classnames('container', {
        [`container-${type}`]: STYLED_PILL_TYPES.includes(type),
        'container-small': props.isSmall,
        'container-default': !STYLED_PILL_TYPES.includes(type),
        'container-unclickable': !props.onRemove && !clickNavigatesToEntity,
        'container-linkable': clickNavigatesToEntity,
    });

    const styles = {
        ...(props.colorName && type !== 'leftBorder'
            ? {backgroundColor: colors[props.colorName]}
            : {}),
        ...(props.colorName && type === 'leftBorder'
            ? {borderLeft: `4px solid ${colors[props.colorName]}`}
            : {}),
    };

    const handleRemove = (e: SyntheticEvent<*>) => {
        e.stopPropagation();

        if (props.onRemove) {
            props.onRemove();
        }
    };

    return (
        <div styleName={classes} style={styles} data-tip={props.tooltipText}>
            {clickNavigatesToEntity ? (
                <a
                    styleName='entity-container'
                    onMouseDown={(e) => e.stopPropagation()}
                    href={props.htmlUrl}
                >
                    {entityName}
                    <div styleName='sublabel'>{props.sublabel}</div>
                </a>
            ) : (
                <span styleName='entity-container'>
                    {entityName}
                    <div styleName='sublabel'>{props.sublabel}</div>
                </span>
            )}
            {props.onRemove && (
                <RemoveButton
                    onClick={handleRemove}
                    size={props.isSmall ? 7 : 9}
                    tooltip={props.removeButtonTooltip}
                />
            )}
        </div>
    );
}
